import './PageSegmentLoading.css';

const PageSegmentLoading = () => {
    return (
        <div className="pageContentSegment loading">
        </div>
    )
}

export default PageSegmentLoading;